import Table from 'components/Control/Table.js'
import {Page} from 'components/Page/index.js'
import useAllMediaRequests from 'logic/AllDanceRequests/useAllMediaRequests.js'

import React from 'react'

const AllMediaRequests = () => {
    const {t18AllMediaRequests, handleRowClick, rows, columns} =
        useAllMediaRequests()

    return (
        <Page title={t18AllMediaRequests('allMediaRequests')}>
            <Table
                rows={rows}
                columns={columns}
                onRowClick={handleRowClick}
                height="748px"
            />
        </Page>
    )
}

export default AllMediaRequests
